module.exports = __webpack_public_path__ + "img/Image-placeholder.1cf4235f.svg";